import { createGlobalStyle } from "styled-components";

export const GlobalStyle = createGlobalStyle`
    *,
    *::before,
    *::after {
        box-sizing: border-box;
        padding: 0;
        margin: 0;
    }
    html {
        height: 100vh;
        background-color: ${({ theme }) => theme.colors.secondaryOffWhite};
        overflow-x: auto;
        overflow-y: auto;
    }
    
`;
